import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialTicker } from './components/SocialTicker';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { PainAgitation } from './components/PainAgitation';
import { Transformation } from './components/Transformation';
import { Science } from './components/Science';
import { Revelation } from './components/Revelation';
import { ProductPresentation } from './components/ProductPresentation';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Comparison } from './components/Comparison';
import { ExpectedResults } from './components/ExpectedResults';
import { Timeline } from './components/Timeline';
import { AppDemo } from './components/AppDemo';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Closing } from './components/Closing';
import { Disclaimer } from './components/Disclaimer';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-brand-bg text-brand-text relative selection:bg-brand-cyan/30 selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <SocialTicker data-id="element-3" />

      <main className="relative z-10 pb-[72px] md:pb-0" data-id="element-4">
        {' '}
        {/* Padding bottom for mobile floating CTA */}
        <Hero data-id="element-5" />
        <Hook data-id="element-6" />
        <PainAgitation data-id="element-7" />
        <Transformation data-id="element-8" />
        <Science data-id="element-9" />
        <Revelation data-id="element-10" />
        <ProductPresentation data-id="element-11" />
        <Bonuses data-id="element-12" />
        <ValueStack data-id="element-13" />
        <Comparison data-id="element-14" />
        <ExpectedResults data-id="element-15" />
        <Timeline data-id="element-16" />
        <AppDemo data-id="element-17" />
        <FAQ data-id="element-18" />
        <Guarantee data-id="element-19" />
        <Testimonials data-id="element-20" />
        <Disclaimer data-id="element-21" />
        <Closing data-id="element-22" />
      </main>

      <Footer data-id="element-23" />
      <FloatingCTA data-id="element-24" />
    </div>;
}